import { atom, useAtom, useSetAtom } from "jotai";
import { Sources } from "../utils/enum";

export const sourceAtom = atom<null | Sources[], [Sources[]], void>(
  null,
  (get, set, newSource) => {
    set(sourceAtom, newSource);
  }
);

const useLiveSource = () => {
  return useAtom(sourceAtom);
};

export const useSetLiveSource = () => useSetAtom(sourceAtom);

export default useLiveSource;
